import React from 'react';
import { cn } from '../../utils/cn';

export const StatusBadge = ({ status }) => {
  const styles = {
    draft: 'bg-slate-100 text-slate-600 border-slate-200',
    in_review: 'bg-amber-100 text-amber-700 border-amber-200',
    finalized: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  };
  const labels = {
    draft: 'Draft',
    in_review: 'In Review',
    finalized: 'Finalized',
  };
  return (
    <span className={cn('status-badge', styles[status] || styles.draft)}>
      {labels[status] || status}
    </span>
  );
};